<template>
  <div class="wallet-summary">
    <div v-for="tile in tiles" :key="tile.key" class="wallet-summary__tile">
      <div class="wallet-summary__label">
        {{ tile.label }}
        <v-tooltip bottom max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-1" color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
          </template>
          <span>{{ tile.hint }}</span>
        </v-tooltip>
      </div>
      <div class="wallet-summary__value" :class="{ 'error--text': tile.value < 0 }">{{ tile.value }} <small>шт.</small></div>
    </div>
  </div>
</template>

<script>
// Плашки остатков корпа. Данные — модель адаптера parseWalletStatistics.
export default {
  name: 'WalletSummary',
  props: {
    wallet: { type: Object, required: true },
    spentLabel: { type: String, default: 'Израсходовано за период' },
  },
  computed: {
    tiles() {
      return [
        {
          key: 'balance',
          label: 'Общий остаток тестов',
          value: this.wallet.totals.balance,
          hint: 'Доступно к распределению (в буфере) плюс уже распределённые менеджерам.',
        },
        {
          key: 'buffer',
          label: 'В буфере',
          value: this.wallet.bufferBalance,
          hint: 'Тесты компании, ещё не распределённые менеджерам.',
        },
        {
          key: 'managers',
          label: 'У менеджеров',
          value: this.wallet.managersBalance,
          hint: 'Тесты, распределённые менеджерам и ещё не назначенные кандидатам.',
        },
        {
          key: 'spent',
          label: this.spentLabel,
          value: this.wallet.totals.spent,
          hint: 'Сколько тестов назначено кандидатам за период. Переводы менеджерам сюда не входят.',
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.wallet-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;

  &__tile {
    padding: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fff;
  }

  &__value small {
    font-size: 13px;
    font-weight: 400;
    color: #757575;
  }

  &__label {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #757575;
  }

  &__value {
    margin-top: 6px;
    font-size: 26px;
    font-weight: 600;
    color: #212121;
  }
}
</style>
